import "core-js/modules/es6.regexp.to-string";
import _typeof from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.sub";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.typed.uint8-array";

/*
 Chen, Yi-Cyuan 2014-2017
 @license MIT
 Kirill, Fomichev 2014
 @license MIT
*/
(function (f, z) {
  var v = function v(n) {
    function y(a, k) {
      var b;
      var c = f.crypto || f.msCrypto;
      if (c && c.getRandomValues && f.Uint8Array) b = new Uint8Array(a), c.getRandomValues(b);else for (b = Array(a), c = 0; c < b.length; c++) {
        b[c] = Math.floor(256 * Math.random());
      }

      for (var c = Array(a), d = 0; d < a; d++) {
        c[d] = k.charCodeAt(b[d] % k.length);
      }

      return String.fromCharCode.apply(null, c);
    }

    function w() {
      return "undefined" !== typeof a.authServerUrl ? "/" == a.authServerUrl.charAt(a.authServerUrl.length - 1) ? a.authServerUrl + "realms/" + encodeURIComponent(a.realm) : a.authServerUrl + "/realms/" + encodeURIComponent(a.realm) : z;
    }

    function r(b, k) {
      function d(p, d, x, N) {
        e = (e + new Date().getTime()) / 2;
        c(p, d, x, e);
        K && (a.tokenParsed && a.tokenParsed.nonce != b.storedNonce || a.refreshTokenParsed && a.refreshTokenParsed.nonce != b.storedNonce || a.idTokenParsed && a.idTokenParsed.nonce != b.storedNonce) ? (console.info("[KEYCLOAK] Invalid nonce, clearing token"), a.clearToken(), k && k.setError()) : N && (a.onAuthSuccess && a.onAuthSuccess(), k && k.setSuccess());
      }

      var x = b.code,
          H = b.error,
          p = b.prompt,
          e = new Date().getTime();
      if (H) "none" != p ? (x = {
        error: H,
        error_description: b.error_description
      }, a.onAuthError && a.onAuthError(x), k && k.setError(x)) : k && k.setSuccess();else if ("standard" != a.flow && (b.access_token || b.id_token) && d(b.access_token, null, b.id_token, !0), "implicit" != a.flow && x) {
        var x = "code\x3d" + x + "\x26grant_type\x3dauthorization_code",
            H = a.endpoints.token(),
            m = new XMLHttpRequest();
        m.open("POST", H, !0);
        m.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        a.clientId && a.clientSecret ? m.setRequestHeader("Authorization", "Basic " + btoa(a.clientId + ":" + a.clientSecret)) : x += "\x26client_id\x3d" + encodeURIComponent(a.clientId);
        x += "\x26redirect_uri\x3d" + b.redirectUri;
        b.pkceCodeVerifier && (x += "\x26code_verifier\x3d" + b.pkceCodeVerifier);
        m.withCredentials = !0;

        m.onreadystatechange = function () {
          if (4 == m.readyState) if (200 == m.status) {
            var b = JSON.parse(m.responseText);
            d(b.access_token, b.refresh_token, b.id_token, "standard" === a.flow);
            F();
          } else a.onAuthError && a.onAuthError(), k && k.setError();
        };

        m.send(x);
      }
    }

    function C(b) {
      function k(b) {
        a.endpoints = b ? {
          authorize: function authorize() {
            return b.authorization_endpoint;
          },
          token: function token() {
            return b.token_endpoint;
          },
          logout: function logout() {
            if (!b.end_session_endpoint) throw "Not supported by the OIDC server";
            return b.end_session_endpoint;
          },
          checkSessionIframe: function checkSessionIframe() {
            if (!b.check_session_iframe) throw "Not supported by the OIDC server";
            return b.check_session_iframe;
          },
          register: function register() {
            throw 'Redirection to "Register user" page not supported in standard OIDC mode';
          },
          userinfo: function userinfo() {
            if (!b.userinfo_endpoint) throw "Not supported by the OIDC server";
            return b.userinfo_endpoint;
          }
        } : {
          authorize: function authorize() {
            return w() + "/protocol/openid-connect/auth";
          },
          token: function token() {
            return w() + "/protocol/openid-connect/token";
          },
          logout: function logout() {
            return w() + "/protocol/openid-connect/logout";
          },
          checkSessionIframe: function checkSessionIframe() {
            var b = w() + "/protocol/openid-connect/login-status-iframe.html";
            a.iframeVersion && (b = b + "?version\x3d" + a.iframeVersion);
            return b;
          },
          register: function register() {
            return w() + "/protocol/openid-connect/registrations";
          },
          userinfo: function userinfo() {
            return w() + "/protocol/openid-connect/userinfo";
          }
        };
      }

      var c = h(!0),
          d;
      n ? "string" === typeof n && (d = n) : d = "keycloak.json";

      if (d) {
        var e = new XMLHttpRequest();
        e.open("GET", d, !0);
        e.setRequestHeader("Accept", "application/json");

        e.onreadystatechange = function () {
          if (4 == e.readyState) if (200 == e.status || 0 == e.status && e.responseText && e.responseURL.startsWith("file:")) {
            var b = JSON.parse(e.responseText);
            a.authServerUrl = b["auth-server-url"];
            a.realm = b.realm;
            a.clientId = b.resource;
            a.clientSecret = (b.credentials || {}).secret;
            k(null);
            c.setSuccess();
          } else c.setError();
        };

        e.send();
      } else {
        if (!n.clientId) throw "clientId missing";
        a.clientId = n.clientId;
        a.clientSecret = (n.credentials || {}).secret;
        if (b = n.oidcProvider) "string" === typeof b ? (b = "/" == b.charAt(b.length - 1) ? b + ".well-known/openid-configuration" : b + "/.well-known/openid-configuration", e = new XMLHttpRequest(), e.open("GET", b, !0), e.setRequestHeader("Accept", "application/json"), e.onreadystatechange = function () {
          if (4 == e.readyState) if (200 == e.status || 0 == e.status && e.responseText && e.responseURL.startsWith("file:")) {
            var a = JSON.parse(e.responseText);
            k(a);
            c.setSuccess();
          } else c.setError();
        }, e.send()) : (k(b), c.setSuccess());else {
          if (!n.url) for (b = document.getElementsByTagName("script"), d = 0; d < b.length; d++) {
            if (b[d].src.match(/.*keycloak\.js/)) {
              n.url = b[d].src.substr(0, b[d].src.indexOf("/js/keycloak.js"));
              break;
            }
          }
          if (!n.realm) throw "realm missing";
          a.authServerUrl = n.url;
          a.realm = n.realm;
          k(null);
          c.setSuccess();
        }
      }

      return c.promise;
    }

    function c(b, k, c, d) {
      a.tokenTimeoutHandle && (clearTimeout(a.tokenTimeoutHandle), a.tokenTimeoutHandle = null);
      k ? (a.refreshToken = k, a.refreshTokenParsed = t(k)) : (delete a.refreshToken, delete a.refreshTokenParsed);
      c ? (a.idToken = c, a.idTokenParsed = t(c)) : (delete a.idToken, delete a.idTokenParsed);

      if (b) {
        if (a.token = b, a.tokenParsed = t(b), a.sessionId = a.tokenParsed.session_state, a.authenticated = !0, a.subject = a.tokenParsed.sub, a.realmAccess = a.tokenParsed.realm_access, a.resourceAccess = a.tokenParsed.resource_access, d && (a.timeSkew = Math.floor(d / 1e3) - a.tokenParsed.iat), null != a.timeSkew && (console.info("[KEYCLOAK] Estimated time difference between browser and server is " + a.timeSkew + " seconds"), a.onTokenExpired)) if (b = 1e3 * (a.tokenParsed.exp - new Date().getTime() / 1e3 + a.timeSkew), console.info("[KEYCLOAK] Token expires in " + Math.round(b / 1e3) + " s"), 0 >= b) a.onTokenExpired();else a.tokenTimeoutHandle = setTimeout(a.onTokenExpired, b);
      } else delete a.token, delete a.tokenParsed, delete a.subject, delete a.realmAccess, delete a.resourceAccess, a.authenticated = !1;
    }

    function t(a) {
      a = a.split(".")[1];
      a = a.replace("/-/g", "+");
      a = a.replace("/_/g", "/");

      switch (a.length % 4) {
        case 0:
          break;

        case 2:
          a += "\x3d\x3d";
          break;

        case 3:
          a += "\x3d";
          break;

        default:
          throw "Invalid token";
      }

      a = (a + "\x3d\x3d\x3d").slice(0, a.length + a.length % 4);
      a = a.replace(/-/g, "+").replace(/_/g, "/");
      a = decodeURIComponent(escape(atob(a)));
      return a = JSON.parse(a);
    }

    function u() {
      var a = y(36, "0123456789abcdef").split("");
      a[14] = "4";
      a[19] = "0123456789abcdef".substr(a[19] & 3 | 8, 1);
      a[8] = a[13] = a[18] = a[23] = "-";
      return a.join("");
    }

    function B(b) {
      a: {
        var k;

        switch (a.flow) {
          case "standard":
            k = ["code", "state", "session_state"];
            break;

          case "implicit":
            k = "access_token token_type id_token state session_state expires_in".split(" ");
            break;

          case "hybrid":
            k = ["access_token", "id_token", "code", "state", "session_state"];
        }

        k.push("error");
        k.push("error_description");
        k.push("error_uri");
        var c = b.indexOf("?"),
            d = b.indexOf("#"),
            e,
            p;
        "query" === a.responseMode && -1 !== c ? (e = b.substring(0, c), p = q(b.substring(c + 1, -1 !== d ? d : b.length), k), "" !== p.paramsString && (e += "?" + p.paramsString), -1 !== d && (e += b.substring(d))) : "fragment" === a.responseMode && -1 !== d && (e = b.substring(0, d), p = q(b.substring(d + 1), k), "" !== p.paramsString && (e += "#" + p.paramsString));
        if (p && p.oauthParams) if ("standard" === a.flow || "hybrid" === a.flow) {
          if ((p.oauthParams.code || p.oauthParams.error) && p.oauthParams.state) {
            p.oauthParams.newUrl = e;
            b = p.oauthParams;
            break a;
          }
        } else if ("implicit" === a.flow && (p.oauthParams.access_token || p.oauthParams.error) && p.oauthParams.state) {
          p.oauthParams.newUrl = e;
          b = p.oauthParams;
          break a;
        }
        b = void 0;
      }

      if (b) {
        if (k = D.get(b.state)) b.valid = !0, b.redirectUri = k.redirectUri, b.storedNonce = k.nonce, b.prompt = k.prompt, b.pkceCodeVerifier = k.pkceCodeVerifier;
        return b;
      }
    }

    function q(a, k) {
      a = a.split("\x26");

      for (var b = {
        paramsString: "",
        oauthParams: {}
      }, c = 0; c < a.length; c++) {
        var d = a[c].split("\x3d");
        -1 !== k.indexOf(d[0]) ? b.oauthParams[d[0]] = d[1] : ("" !== b.paramsString && (b.paramsString += "\x26"), b.paramsString += a[c]);
      }

      return b;
    }

    function h(b) {
      return !b && a.useNativePromise ? I() : J();
    }

    function I() {
      var a = {
        setSuccess: function setSuccess(b) {
          a.resolve(b);
        },
        setError: function setError(b) {
          a.reject(b);
        }
      };
      a.promise = new Promise(function (b, c) {
        a.resolve = b;
        a.reject = c;
      });
      return a;
    }

    function J() {
      var a = {
        setSuccess: function setSuccess(b) {
          a.success = !0;
          a.result = b;
          a.successCallback && a.successCallback(b);
        },
        setError: function setError(b) {
          a.error = !0;
          a.result = b;
          a.errorCallback && a.errorCallback(b);
        },
        promise: {
          success: function success(b) {
            a.success ? b(a.result) : a.error || (a.successCallback = b);
            return a.promise;
          },
          error: function error(b) {
            a.error ? b(a.result) : a.success || (a.errorCallback = b);
            return a.promise;
          }
        }
      };
      return a;
    }

    function G() {
      var b = h(!0);
      if (!d.enable || d.iframe) return b.setSuccess(), b.promise;
      var c = document.createElement("iframe");
      d.iframe = c;

      c.onload = function () {
        var c = a.endpoints.authorize();
        "/" === c.charAt(0) ? (c = f.location.origin ? f.location.origin : f.location.protocol + "//" + f.location.hostname + (f.location.port ? ":" + f.location.port : ""), d.iframeOrigin = c) : d.iframeOrigin = c.substring(0, c.indexOf("/", 8));
        b.setSuccess();
      };

      var e = a.endpoints.checkSessionIframe();
      c.setAttribute("src", e);
      c.setAttribute("title", "keycloak-session-iframe");
      c.style.display = "none";
      document.body.appendChild(c);
      f.addEventListener("message", function (b) {
        if (b.origin === d.iframeOrigin && d.iframe.contentWindow === b.source && ("unchanged" == b.data || "changed" == b.data || "error" == b.data)) {
          "unchanged" != b.data && a.clearToken();

          for (var c = d.callbackList.splice(0, d.callbackList.length), p = c.length - 1; 0 <= p; --p) {
            var k = c[p];
            "error" == b.data ? k.setError() : k.setSuccess("unchanged" == b.data);
          }
        }
      }, !1);
      return b.promise;
    }

    function F() {
      d.enable && a.token && setTimeout(function () {
        E().success(function (a) {
          a && F();
        });
      }, 1e3 * d.interval);
    }

    function E() {
      var b = h(!0);

      if (d.iframe && d.iframeOrigin) {
        var c = a.clientId + " " + (a.sessionId ? a.sessionId : "");
        d.callbackList.push(b);
        var e = d.iframeOrigin;
        1 == d.callbackList.length && d.iframe.contentWindow.postMessage(c, e);
      } else b.setSuccess();

      return b.promise;
    }

    function A(b) {
      if (!b || "default" == b) return {
        login: function login(b) {
          f.location.replace(a.createLoginUrl(b));
          return h().promise;
        },
        logout: function logout(b) {
          f.location.replace(a.createLogoutUrl(b));
          return h().promise;
        },
        register: function register(b) {
          f.location.replace(a.createRegisterUrl(b));
          return h().promise;
        },
        accountManagement: function accountManagement() {
          var b = a.createAccountUrl();
          if ("undefined" !== typeof b) f.location.href = b;else throw "Not supported by the OIDC server";
          return h(!1).promise;
        },
        redirectUri: function redirectUri(b, c) {
          1 == arguments.length && (c = !0);
          return b && b.redirectUri ? b.redirectUri : a.redirectUri ? a.redirectUri : location.href;
        }
      };

      if ("cordova" == b) {
        d.enable = !1;

        var c = function c(a, b, _c) {
          return f.cordova && f.cordova.InAppBrowser ? f.cordova.InAppBrowser.open(a, b, _c) : f.open(a, b, _c);
        },
            e = function e(a) {
          return a && a.cordovaOptions ? Object.keys(a.cordovaOptions).reduce(function (b, c) {
            b[c] = a.cordovaOptions[c];
            return b;
          }, {}) : {};
        },
            m = function m(a) {
          return Object.keys(a).reduce(function (b, c) {
            b.push(c + "\x3d" + a[c]);
            return b;
          }, []).join(",");
        },
            g = function g(a) {
          var b = e(a);
          b.location = "no";
          a && "none" == a.prompt && (b.hidden = "yes");
          return m(b);
        };

        return {
          login: function login(b) {
            var d = h(!1),
                k = g(b);
            b = a.createLoginUrl(b);
            var e = c(b, "_blank", k),
                p = !1,
                m = !1;
            e.addEventListener("loadstart", function (a) {
              0 == a.url.indexOf("http://localhost") && (a = B(a.url), r(a, d), m = !0, e.close(), p = !0);
            });
            e.addEventListener("loaderror", function (a) {
              p || (0 == a.url.indexOf("http://localhost") ? (a = B(a.url), r(a, d), m = !0, e.close(), p = !0) : (d.setError(), m = !0, e.close()));
            });
            e.addEventListener("exit", function (a) {
              m || d.setError({
                reason: "closed_by_user"
              });
            });
            return d.promise;
          },
          logout: function logout(b) {
            var d = h(!1);
            b = a.createLogoutUrl(b);
            var e = c(b, "_blank", "location\x3dno,hidden\x3dyes"),
                k;
            e.addEventListener("loadstart", function (a) {
              0 == a.url.indexOf("http://localhost") && e.close();
            });
            e.addEventListener("loaderror", function (a) {
              0 != a.url.indexOf("http://localhost") && (k = !0);
              e.close();
            });
            e.addEventListener("exit", function (b) {
              k ? d.setError() : (a.clearToken(), d.setSuccess());
            });
            return d.promise;
          },
          register: function register(b) {
            var d = h(!1),
                e = a.createRegisterUrl();
            b = g(b);
            var k = c(e, "_blank", b);
            k.addEventListener("loadstart", function (a) {
              0 == a.url.indexOf("http://localhost") && (k.close(), a = B(a.url), r(a, d));
            });
            return d.promise;
          },
          accountManagement: function accountManagement() {
            var b = a.createAccountUrl();

            if ("undefined" !== typeof b) {
              var d = c(b, "_blank", "location\x3dno");
              d.addEventListener("loadstart", function (a) {
                0 == a.url.indexOf("http://localhost") && d.close();
              });
            } else throw "Not supported by the OIDC server";
          },
          redirectUri: function redirectUri(a) {
            return "http://localhost";
          }
        };
      }

      if ("cordova-native" == b) return d.enable = !1, {
        login: function login(b) {
          var c = h(!1);
          b = a.createLoginUrl(b);
          universalLinks.subscribe("keycloak", function (a) {
            universalLinks.unsubscribe("keycloak");
            f.cordova.plugins.browsertab.close();
            a = B(a.url);
            r(a, c);
          });
          f.cordova.plugins.browsertab.openUrl(b);
          return c.promise;
        },
        logout: function logout(b) {
          var c = h(!1);
          b = a.createLogoutUrl(b);
          universalLinks.subscribe("keycloak", function (b) {
            universalLinks.unsubscribe("keycloak");
            f.cordova.plugins.browsertab.close();
            a.clearToken();
            c.setSuccess();
          });
          f.cordova.plugins.browsertab.openUrl(b);
          return c.promise;
        },
        register: function register(b) {
          var c = h(!1);
          b = a.createRegisterUrl(b);
          universalLinks.subscribe("keycloak", function (a) {
            universalLinks.unsubscribe("keycloak");
            f.cordova.plugins.browsertab.close();
            a = B(a.url);
            r(a, c);
          });
          f.cordova.plugins.browsertab.openUrl(b);
          return c.promise;
        },
        accountManagement: function accountManagement() {
          var b = a.createAccountUrl();
          if ("undefined" !== typeof b) f.cordova.plugins.browsertab.openUrl(b);else throw "Not supported by the OIDC server";
        },
        redirectUri: function redirectUri(b) {
          return b && b.redirectUri ? b.redirectUri : a.redirectUri ? a.redirectUri : "http://localhost";
        }
      };
      throw "invalid adapter type: " + b;
    }

    if (!(this instanceof v)) return new v(n);

    for (var a = this, m, e = [], D, d = {
      enable: !0,
      callbackList: [],
      interval: 5
    }, l = document.getElementsByTagName("script"), g = 0; g < l.length; g++) {
      -1 === l[g].src.indexOf("keycloak.js") && -1 === l[g].src.indexOf("keycloak.min.js") || -1 === l[g].src.indexOf("version\x3d") || (a.iframeVersion = l[g].src.substring(l[g].src.indexOf("version\x3d") + 8).split("\x26")[0]);
    }

    var K = !0;

    a.init = function (b) {
      function e() {
        var c = function c(b) {
          b || (e.prompt = "none");
          a.login(e).success(function () {
            l.setSuccess();
          }).error(function () {
            l.setError();
          });
        },
            e = {};

        switch (b.onLoad) {
          case "check-sso":
            d.enable ? G().success(function () {
              E().success(function (a) {
                a ? l.setSuccess() : c(!1);
              }).error(function () {
                l.setError();
              });
            }) : c(!1);
            break;

          case "login-required":
            c(!0);
            break;

          default:
            throw "Invalid value for onLoad";
        }
      }

      a.authenticated = !1;

      a: {
        try {
          D = new L();
          break a;
        } catch (p) {}

        D = new M();
      }

      var g = ["default", "cordova", "cordova-native"];
      m = b && -1 < g.indexOf(b.adapter) ? A(b.adapter) : b && "object" === _typeof(b.adapter) ? b.adapter : f.Cordova || f.cordova ? A("cordova") : A();

      if (b) {
        "undefined" !== typeof b.useNonce && (K = b.useNonce);
        "undefined" !== typeof b.checkLoginIframe && (d.enable = b.checkLoginIframe);
        b.checkLoginIframeInterval && (d.interval = b.checkLoginIframeInterval);
        a.useNativePromise = "native" === b.promiseType ? "function" === typeof Promise : !1;
        "login-required" === b.onLoad && (a.loginRequired = !0);
        if (b.responseMode) if ("query" === b.responseMode || "fragment" === b.responseMode) a.responseMode = b.responseMode;else throw "Invalid value for responseMode";

        if (b.flow) {
          switch (b.flow) {
            case "standard":
              a.responseType = "code";
              break;

            case "implicit":
              a.responseType = "id_token token";
              break;

            case "hybrid":
              a.responseType = "code id_token token";
              break;

            default:
              throw "Invalid value for flow";
          }

          a.flow = b.flow;
        }

        null != b.timeSkew && (a.timeSkew = b.timeSkew);
        b.redirectUri && (a.redirectUri = b.redirectUri);

        if (b.pkceMethod) {
          if ("S256" !== b.pkceMethod) throw "Invalid value for pkceMethod";
          a.pkceMethod = b.pkceMethod;
        }
      }

      a.responseMode || (a.responseMode = "fragment");
      a.responseType || (a.responseType = "code", a.flow = "standard");
      var x = h(!1),
          l = h(!0);
      l.promise.success(function () {
        a.onReady && a.onReady(a.authenticated);
        x.setSuccess(a.authenticated);
      }).error(function (a) {
        x.setError(a);
      });
      g = C(n);
      g.success(function () {
        var k = B(f.location.href);
        k && f.history.replaceState(f.history.state, null, k.newUrl);
        if (k && k.valid) return G().success(function () {
          r(k, l);
        }).error(function (a) {
          l.setError();
        });
        b ? b.token && b.refreshToken ? (c(b.token, b.refreshToken, b.idToken), d.enable ? G().success(function () {
          E().success(function (b) {
            b ? (a.onAuthSuccess && a.onAuthSuccess(), l.setSuccess(), F()) : l.setSuccess();
          }).error(function () {
            l.setError();
          });
        }) : a.updateToken(-1).success(function () {
          a.onAuthSuccess && a.onAuthSuccess();
          l.setSuccess();
        }).error(function () {
          a.onAuthError && a.onAuthError();
          b.onLoad ? e() : l.setError();
        })) : b.onLoad ? e() : l.setSuccess() : l.setSuccess();
      });
      g.error(function () {
        x.setError();
      });
      return x.promise;
    };

    a.login = function (a) {
      return m.login(a);
    };

    a.createLoginUrl = function (b) {
      var c = u(),
          d = u(),
          e = m.redirectUri(b),
          g = {
        state: c,
        nonce: d,
        redirectUri: encodeURIComponent(e)
      };
      b && b.prompt && (g.prompt = b.prompt);
      var l;
      l = b && "register" == b.action ? a.endpoints.register() : a.endpoints.authorize();
      var f;
      f = b && b.scope ? -1 != b.scope.indexOf("openid") ? b.scope : "openid " + b.scope : "openid";
      c = l + "?client_id\x3d" + encodeURIComponent(a.clientId) + "\x26redirect_uri\x3d" + encodeURIComponent(e) + "\x26state\x3d" + encodeURIComponent(c) + "\x26response_mode\x3d" + encodeURIComponent(a.responseMode) + "\x26response_type\x3d" + encodeURIComponent(a.responseType) + "\x26scope\x3d" + encodeURIComponent(f);
      K && (c = c + "\x26nonce\x3d" + encodeURIComponent(d));
      b && b.prompt && (c += "\x26prompt\x3d" + encodeURIComponent(b.prompt));
      b && b.maxAge && (c += "\x26max_age\x3d" + encodeURIComponent(b.maxAge));
      b && b.loginHint && (c += "\x26login_hint\x3d" + encodeURIComponent(b.loginHint));
      b && b.idpHint && (c += "\x26kc_idp_hint\x3d" + encodeURIComponent(b.idpHint));
      b && b.locale && (c += "\x26ui_locales\x3d" + encodeURIComponent(b.locale));
      b && b.kcLocale && (c += "\x26kc_locale\x3d" + encodeURIComponent(b.kcLocale));

      if (a.pkceMethod) {
        b = y(96, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
        g.pkceCodeVerifier = b;

        a: switch (a.pkceMethod) {
          case "S256":
            b = new Uint8Array(sha256.arrayBuffer(b));
            b = base64js.fromByteArray(b).replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
            break a;

          default:
            throw "Invalid value for pkceMethod";
        }

        c = c + ("\x26code_challenge\x3d" + b) + ("\x26code_challenge_method\x3d" + a.pkceMethod);
      }

      D.add(g);
      return c;
    };

    a.logout = function (a) {
      return m.logout(a);
    };

    a.createLogoutUrl = function (b) {
      return a.endpoints.logout() + "?redirect_uri\x3d" + encodeURIComponent(m.redirectUri(b, !1));
    };

    a.register = function (a) {
      return m.register(a);
    };

    a.createRegisterUrl = function (b) {
      b || (b = {});
      b.action = "register";
      return a.createLoginUrl(b);
    };

    a.createAccountUrl = function (b) {
      var c = w(),
          d = z;
      "undefined" !== typeof c && (d = c + "/account?referrer\x3d" + encodeURIComponent(a.clientId) + "\x26referrer_uri\x3d" + encodeURIComponent(m.redirectUri(b)));
      return d;
    };

    a.accountManagement = function () {
      return m.accountManagement();
    };

    a.hasRealmRole = function (b) {
      var c = a.realmAccess;
      return !!c && 0 <= c.roles.indexOf(b);
    };

    a.hasResourceRole = function (b, c) {
      if (!a.resourceAccess) return !1;
      c = a.resourceAccess[c || a.clientId];
      return !!c && 0 <= c.roles.indexOf(b);
    };

    a.loadUserProfile = function () {
      var b = w() + "/account",
          c = new XMLHttpRequest();
      c.open("GET", b, !0);
      c.setRequestHeader("Accept", "application/json");
      c.setRequestHeader("Authorization", "bearer " + a.token);
      var d = h(!1);

      c.onreadystatechange = function () {
        4 == c.readyState && (200 == c.status ? (a.profile = JSON.parse(c.responseText), d.setSuccess(a.profile)) : d.setError());
      };

      c.send();
      return d.promise;
    };

    a.loadUserInfo = function () {
      var b = a.endpoints.userinfo(),
          c = new XMLHttpRequest();
      c.open("GET", b, !0);
      c.setRequestHeader("Accept", "application/json");
      c.setRequestHeader("Authorization", "bearer " + a.token);
      var d = h(!1);

      c.onreadystatechange = function () {
        4 == c.readyState && (200 == c.status ? (a.userInfo = JSON.parse(c.responseText), d.setSuccess(a.userInfo)) : d.setError());
      };

      c.send();
      return d.promise;
    };

    a.isTokenExpired = function (b) {
      if (!a.tokenParsed || !a.refreshToken && "implicit" != a.flow) throw "Not authenticated";
      if (null == a.timeSkew) return console.info("[KEYCLOAK] Unable to determine if token is expired as timeskew is not set"), !0;
      var c = a.tokenParsed.exp - Math.ceil(new Date().getTime() / 1e3) + a.timeSkew;

      if (b) {
        if (isNaN(b)) throw "Invalid minValidity";
        c -= b;
      }

      return 0 > c;
    };

    a.updateToken = function (b) {
      var m = h(!1);
      if (!a.refreshToken) return m.setError(), m.promise;
      b = b || 5;

      var g = function g() {
        var d = !1;
        if (-1 == b) d = !0, console.info("[KEYCLOAK] Refreshing token: forced refresh");else if (!a.tokenParsed || a.isTokenExpired(b)) d = !0, console.info("[KEYCLOAK] Refreshing token: token expired");

        if (d) {
          var d = "grant_type\x3drefresh_token\x26refresh_token\x3d" + a.refreshToken,
              g = a.endpoints.token();
          e.push(m);

          if (1 == e.length) {
            var k = new XMLHttpRequest();
            k.open("POST", g, !0);
            k.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            k.withCredentials = !0;
            a.clientId && a.clientSecret ? k.setRequestHeader("Authorization", "Basic " + btoa(a.clientId + ":" + a.clientSecret)) : d += "\x26client_id\x3d" + encodeURIComponent(a.clientId);
            var l = new Date().getTime();

            k.onreadystatechange = function () {
              if (4 == k.readyState) if (200 == k.status) {
                console.info("[KEYCLOAK] Token refreshed");
                l = (l + new Date().getTime()) / 2;
                var b = JSON.parse(k.responseText);
                c(b.access_token, b.refresh_token, b.id_token, l);
                a.onAuthRefreshSuccess && a.onAuthRefreshSuccess();

                for (b = e.pop(); null != b; b = e.pop()) {
                  b.setSuccess(!0);
                }
              } else for (console.warn("[KEYCLOAK] Failed to refresh token"), 400 == k.status && a.clearToken(), a.onAuthRefreshError && a.onAuthRefreshError(), b = e.pop(); null != b; b = e.pop()) {
                b.setError(!0);
              }
            };

            k.send(d);
          }
        } else m.setSuccess(!1);
      };

      d.enable ? E().success(function () {
        g();
      }).error(function () {
        m.setError();
      }) : g();
      return m.promise;
    };

    a.clearToken = function () {
      a.token && (c(null, null, null), a.onAuthLogout && a.onAuthLogout(), a.loginRequired && a.login());
    };

    a.callback_id = 0;

    var L = function L() {
      function a() {
        for (var a = new Date().getTime(), b = 0; b < localStorage.length; b++) {
          var c = localStorage.key(b);

          if (c && 0 == c.indexOf("kc-callback-")) {
            var d = localStorage.getItem(c);
            if (d) try {
              var e = JSON.parse(d).expires;
              (!e || e < a) && localStorage.removeItem(c);
            } catch (O) {
              localStorage.removeItem(c);
            }
          }
        }
      }

      if (!(this instanceof L)) return new L();
      localStorage.setItem("kc-test", "test");
      localStorage.removeItem("kc-test");

      this.get = function (b) {
        if (b) {
          b = "kc-callback-" + b;
          var c = localStorage.getItem(b);
          c && (localStorage.removeItem(b), c = JSON.parse(c));
          a();
          return c;
        }
      };

      this.add = function (b) {
        a();
        var c = "kc-callback-" + b.state;
        b.expires = new Date().getTime() + 36e5;
        localStorage.setItem(c, JSON.stringify(b));
      };
    },
        M = function M() {
      if (!(this instanceof M)) return new M();

      this.get = function (b) {
        if (b) {
          var d;

          a: {
            d = "kc-callback-" + b + "\x3d";

            for (var e = document.cookie.split(";"), m = 0; m < e.length; m++) {
              for (var g = e[m]; " " == g.charAt(0);) {
                g = g.substring(1);
              }

              if (0 == g.indexOf(d)) {
                d = g.substring(d.length, g.length);
                break a;
              }
            }

            d = "";
          }

          c("kc-callback-" + b, "", a(-100));
          if (d) return JSON.parse(d);
        }
      };

      this.add = function (b) {
        c("kc-callback-" + b.state, JSON.stringify(b), a(60));
      };

      this.removeItem = function (b) {
        c(b, "", a(-100));
      };

      var a = function a(_a) {
        var b = new Date();
        b.setTime(b.getTime() + 6e4 * _a);
        return b;
      },
          c = function c(a, b, _c2) {
        a = a + "\x3d" + b + "; expires\x3d" + _c2.toUTCString() + "; ";
        document.cookie = a;
      };
    };
  };

  "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) && module && "object" === _typeof(module.exports) ? module.exports = v : (f.Keycloak = v, "function" === typeof define && define.amd && define("keycloak", [], function () {
    return v;
  }));
})(window);

!function () {
  function f(a, c) {
    c ? (h[0] = h[16] = h[1] = h[2] = h[3] = h[4] = h[5] = h[6] = h[7] = h[8] = h[9] = h[10] = h[11] = h[12] = h[13] = h[14] = h[15] = 0, this.blocks = h) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    a ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225);
    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = !1;
    this.first = !0;
    this.is224 = a;
  }

  function z(a, c, e) {
    var m;
    m = _typeof(a);

    if ("string" === m) {
      var d,
          l = [],
          g = a.length,
          h = 0;

      for (m = 0; m < g; ++m) {
        128 > (d = a.charCodeAt(m)) ? l[h++] = d : 2048 > d ? (l[h++] = 192 | d >> 6, l[h++] = 128 | 63 & d) : 55296 > d || 57344 <= d ? (l[h++] = 224 | d >> 12, l[h++] = 128 | d >> 6 & 63, l[h++] = 128 | 63 & d) : (d = 65536 + ((1023 & d) << 10 | 1023 & a.charCodeAt(++m)), l[h++] = 240 | d >> 18, l[h++] = 128 | d >> 12 & 63, l[h++] = 128 | d >> 6 & 63, l[h++] = 128 | 63 & d);
      }

      a = l;
    } else {
      if ("object" !== m) throw Error(v);
      if (null === a) throw Error(v);
      if (C && a.constructor === ArrayBuffer) a = new Uint8Array(a);else if (!(Array.isArray(a) || C && ArrayBuffer.isView(a))) throw Error(v);
    }

    64 < a.length && (a = new f(c, !0).update(a).array());
    d = [];
    l = [];

    for (m = 0; 64 > m; ++m) {
      g = a[m] || 0, d[m] = 92 ^ g, l[m] = 54 ^ g;
    }

    f.call(this, c, e);
    this.update(l);
    this.oKeyPad = d;
    this.inner = !0;
    this.sharedMemory = e;
  }

  var v = "input is invalid type",
      n = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)),
      y = n ? window : {};
  y.JS_SHA256_NO_WINDOW && (n = !1);
  var n = !n && "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)),
      w = !y.JS_SHA256_NO_NODE_JS && "object" == (typeof process === "undefined" ? "undefined" : _typeof(process)) && process.versions && process.versions.node;
  w ? y = global : n && (y = self);
  var n = !y.JS_SHA256_NO_COMMON_JS && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports,
      r = "function" == typeof define && define.amd,
      C = !y.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
      c = "0123456789abcdef".split(""),
      t = [-2147483648, 8388608, 32768, 128],
      u = [24, 16, 8, 0],
      B = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
      q = ["hex", "array", "digest", "arrayBuffer"],
      h = [];
  !y.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (a) {
    return "[object Array]" === Object.prototype.toString.call(a);
  });
  !C || !y.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (a) {
    return "object" == _typeof(a) && a.buffer && a.buffer.constructor === ArrayBuffer;
  });

  var I = function I(a, c) {
    return function (e) {
      return new f(c, !0).update(e)[a]();
    };
  },
      J = function J(a) {
    var c = I("hex", a);
    w && (c = G(c, a));

    c.create = function () {
      return new f(a);
    };

    c.update = function (a) {
      return c.create().update(a);
    };

    for (var e = 0; e < q.length; ++e) {
      var D = q[e];
      c[D] = I(D, a);
    }

    return c;
  },
      G = function G(a, c) {
    var e = eval("require('crypto')"),
        m = eval("require('buffer').Buffer"),
        d = c ? "sha224" : "sha256";
    return function (c) {
      if ("string" == typeof c) return e.createHash(d).update(c, "utf8").digest("hex");
      if (null === c || void 0 === c) throw Error(v);
      return c.constructor === ArrayBuffer && (c = new Uint8Array(c)), Array.isArray(c) || ArrayBuffer.isView(c) || c.constructor === m ? e.createHash(d).update(new m(c)).digest("hex") : a(c);
    };
  },
      F = function F(a, c) {
    return function (e, m) {
      return new z(e, c, !0).update(m)[a]();
    };
  },
      E = function E(a) {
    var c = F("hex", a);

    c.create = function (c) {
      return new z(c, a);
    };

    c.update = function (a, e) {
      return c.create(a).update(e);
    };

    for (var e = 0; e < q.length; ++e) {
      var f = q[e];
      c[f] = F(f, a);
    }

    return c;
  };

  f.prototype.update = function (a) {
    if (!this.finalized) {
      var c,
          e = _typeof(a);

      if ("string" !== e) {
        if ("object" !== e) throw Error(v);
        if (null === a) throw Error(v);
        if (C && a.constructor === ArrayBuffer) a = new Uint8Array(a);else if (!(Array.isArray(a) || C && ArrayBuffer.isView(a))) throw Error(v);
        c = !0;
      }

      for (var f, d = 0, l = a.length, g = this.blocks; d < l;) {
        if (this.hashed && (this.hashed = !1, g[0] = this.block, g[16] = g[1] = g[2] = g[3] = g[4] = g[5] = g[6] = g[7] = g[8] = g[9] = g[10] = g[11] = g[12] = g[13] = g[14] = g[15] = 0), c) for (e = this.start; d < l && 64 > e; ++d) {
          g[e >> 2] |= a[d] << u[3 & e++];
        } else for (e = this.start; d < l && 64 > e; ++d) {
          128 > (f = a.charCodeAt(d)) ? g[e >> 2] |= f << u[3 & e++] : 2048 > f ? (g[e >> 2] |= (192 | f >> 6) << u[3 & e++], g[e >> 2] |= (128 | 63 & f) << u[3 & e++]) : 55296 > f || 57344 <= f ? (g[e >> 2] |= (224 | f >> 12) << u[3 & e++], g[e >> 2] |= (128 | f >> 6 & 63) << u[3 & e++], g[e >> 2] |= (128 | 63 & f) << u[3 & e++]) : (f = 65536 + ((1023 & f) << 10 | 1023 & a.charCodeAt(++d)), g[e >> 2] |= (240 | f >> 18) << u[3 & e++], g[e >> 2] |= (128 | f >> 12 & 63) << u[3 & e++], g[e >> 2] |= (128 | f >> 6 & 63) << u[3 & e++], g[e >> 2] |= (128 | 63 & f) << u[3 & e++]);
        }
        this.lastByteIndex = e;
        this.bytes += e - this.start;
        64 <= e ? (this.block = g[16], this.start = e - 64, this.hash(), this.hashed = !0) : this.start = e;
      }

      return 4294967295 < this.bytes && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes %= 4294967296), this;
    }
  };

  f.prototype.finalize = function () {
    if (!this.finalized) {
      this.finalized = !0;
      var a = this.blocks,
          c = this.lastByteIndex;
      a[16] = this.block;
      a[c >> 2] |= t[3 & c];
      this.block = a[16];
      56 <= c && (this.hashed || this.hash(), a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0);
      a[14] = this.hBytes << 3 | this.bytes >>> 29;
      a[15] = this.bytes << 3;
      this.hash();
    }
  };

  f.prototype.hash = function () {
    var a,
        c,
        e,
        f,
        d,
        l,
        g,
        h = this.h0,
        t = this.h1,
        u = this.h2,
        b = this.h3,
        k = this.h4,
        n = this.h5,
        x = this.h6,
        q = this.h7,
        p = this.blocks;

    for (a = 16; 64 > a; ++a) {
      c = ((d = p[a - 15]) >>> 7 | d << 25) ^ (d >>> 18 | d << 14) ^ d >>> 3, e = ((d = p[a - 2]) >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10, p[a] = p[a - 16] + c + p[a - 7] + e << 0;
    }

    g = t & u;

    for (a = 0; 64 > a; a += 4) {
      this.first ? (this.is224 ? (l = 300032, q = (d = p[0] - 1413257819) - 150054599 << 0, b = d + 24177077 << 0) : (l = 704751109, q = (d = p[0] - 210244248) - 1521486534 << 0, b = d + 143694565 << 0), this.first = !1) : (c = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), f = (l = h & t) ^ h & u ^ g, q = b + (d = q + ((k >>> 6 | k << 26) ^ (k >>> 11 | k << 21) ^ (k >>> 25 | k << 7)) + (k & n ^ ~k & x) + B[a] + p[a]) << 0, b = d + (c + f) << 0), c = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10), f = (g = b & h) ^ b & t ^ l, x = u + (d = x + ((q >>> 6 | q << 26) ^ (q >>> 11 | q << 21) ^ (q >>> 25 | q << 7)) + (q & k ^ ~q & n) + B[a + 1] + p[a + 1]) << 0, c = ((u = d + (c + f) << 0) >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), f = (e = u & b) ^ u & h ^ g, n = t + (d = n + ((x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)) + (x & q ^ ~x & k) + B[a + 2] + p[a + 2]) << 0, c = ((t = d + (c + f) << 0) >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10), f = (g = t & u) ^ t & b ^ e, k = h + (d = k + ((n >>> 6 | n << 26) ^ (n >>> 11 | n << 21) ^ (n >>> 25 | n << 7)) + (n & x ^ ~n & q) + B[a + 3] + p[a + 3]) << 0, h = d + (c + f) << 0;
    }

    this.h0 = this.h0 + h << 0;
    this.h1 = this.h1 + t << 0;
    this.h2 = this.h2 + u << 0;
    this.h3 = this.h3 + b << 0;
    this.h4 = this.h4 + k << 0;
    this.h5 = this.h5 + n << 0;
    this.h6 = this.h6 + x << 0;
    this.h7 = this.h7 + q << 0;
  };

  f.prototype.hex = function () {
    this.finalize();
    var a = this.h0,
        f = this.h1,
        e = this.h2,
        h = this.h3,
        d = this.h4,
        l = this.h5,
        g = this.h6,
        t = this.h7,
        a = c[a >> 28 & 15] + c[a >> 24 & 15] + c[a >> 20 & 15] + c[a >> 16 & 15] + c[a >> 12 & 15] + c[a >> 8 & 15] + c[a >> 4 & 15] + c[15 & a] + c[f >> 28 & 15] + c[f >> 24 & 15] + c[f >> 20 & 15] + c[f >> 16 & 15] + c[f >> 12 & 15] + c[f >> 8 & 15] + c[f >> 4 & 15] + c[15 & f] + c[e >> 28 & 15] + c[e >> 24 & 15] + c[e >> 20 & 15] + c[e >> 16 & 15] + c[e >> 12 & 15] + c[e >> 8 & 15] + c[e >> 4 & 15] + c[15 & e] + c[h >> 28 & 15] + c[h >> 24 & 15] + c[h >> 20 & 15] + c[h >> 16 & 15] + c[h >> 12 & 15] + c[h >> 8 & 15] + c[h >> 4 & 15] + c[15 & h] + c[d >> 28 & 15] + c[d >> 24 & 15] + c[d >> 20 & 15] + c[d >> 16 & 15] + c[d >> 12 & 15] + c[d >> 8 & 15] + c[d >> 4 & 15] + c[15 & d] + c[l >> 28 & 15] + c[l >> 24 & 15] + c[l >> 20 & 15] + c[l >> 16 & 15] + c[l >> 12 & 15] + c[l >> 8 & 15] + c[l >> 4 & 15] + c[15 & l] + c[g >> 28 & 15] + c[g >> 24 & 15] + c[g >> 20 & 15] + c[g >> 16 & 15] + c[g >> 12 & 15] + c[g >> 8 & 15] + c[g >> 4 & 15] + c[15 & g];
    return this.is224 || (a += c[t >> 28 & 15] + c[t >> 24 & 15] + c[t >> 20 & 15] + c[t >> 16 & 15] + c[t >> 12 & 15] + c[t >> 8 & 15] + c[t >> 4 & 15] + c[15 & t]), a;
  };

  f.prototype.toString = f.prototype.hex;

  f.prototype.digest = function () {
    this.finalize();
    var a = this.h0,
        c = this.h1,
        e = this.h2,
        f = this.h3,
        d = this.h4,
        h = this.h5,
        g = this.h6,
        t = this.h7,
        a = [a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a, c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, 255 & c, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, f >> 24 & 255, f >> 16 & 255, f >> 8 & 255, 255 & f, d >> 24 & 255, d >> 16 & 255, d >> 8 & 255, 255 & d, h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h, g >> 24 & 255, g >> 16 & 255, g >> 8 & 255, 255 & g];
    return this.is224 || a.push(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t), a;
  };

  f.prototype.array = f.prototype.digest;

  f.prototype.arrayBuffer = function () {
    this.finalize();
    var a = new ArrayBuffer(this.is224 ? 28 : 32),
        c = new DataView(a);
    return c.setUint32(0, this.h0), c.setUint32(4, this.h1), c.setUint32(8, this.h2), c.setUint32(12, this.h3), c.setUint32(16, this.h4), c.setUint32(20, this.h5), c.setUint32(24, this.h6), this.is224 || c.setUint32(28, this.h7), a;
  };

  z.prototype = new f();

  z.prototype.finalize = function () {
    if (f.prototype.finalize.call(this), this.inner) {
      this.inner = !1;
      var a = this.array();
      f.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(a);
      f.prototype.finalize.call(this);
    }
  };

  var A = J();
  A.sha256 = A;
  A.sha224 = J(!0);
  A.sha256.hmac = E();
  A.sha224.hmac = E(!0);
  n ? module.exports = A : (y.sha256 = A.sha256, y.sha224 = A.sha224, r && define(function () {
    return A;
  }));
}();

(function (f) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" !== typeof module ? module.exports = f() : "function" === typeof define && define.amd ? define([], f) : ("undefined" !== typeof window ? window : "undefined" !== typeof global ? global : "undefined" !== typeof self ? self : this).base64js = f();
})(function () {
  return function () {
    function f(z, v, n) {
      function y(r, c) {
        if (!v[r]) {
          if (!z[r]) {
            var t = "function" == typeof require && require;
            if (!c && t) return t(r, !0);
            if (w) return w(r, !0);
            c = Error("Cannot find module '" + r + "'");
            throw c.code = "MODULE_NOT_FOUND", c;
          }

          c = v[r] = {
            exports: {}
          };
          z[r][0].call(c.exports, function (c) {
            return y(z[r][1][c] || c);
          }, c, c.exports, f, z, v, n);
        }

        return v[r].exports;
      }

      for (var w = "function" == typeof require && require, r = 0; r < n.length; r++) {
        y(n[r]);
      }

      return y;
    }

    return f;
  }()({
    "/": [function (f, z, v) {
      function n(c) {
        var f = c.length;
        if (0 < f % 4) throw Error("Invalid string. Length must be a multiple of 4");
        c = c.indexOf("\x3d");
        -1 === c && (c = f);
        return [c, c === f ? 0 : 4 - c % 4];
      }

      function y(c, f, n) {
        for (var t = [], q = f; q < n; q += 3) {
          f = (c[q] << 16 & 16711680) + (c[q + 1] << 8 & 65280) + (c[q + 2] & 255), t.push(w[f >> 18 & 63] + w[f >> 12 & 63] + w[f >> 6 & 63] + w[f & 63]);
        }

        return t.join("");
      }

      v.byteLength = function (c) {
        c = n(c);
        var f = c[1];
        return 3 * (c[0] + f) / 4 - f;
      };

      v.toByteArray = function (c) {
        var f,
            u = n(c);
        f = u[0];

        for (var u = u[1], w = new C(3 * (f + u) / 4 - u), q = 0, h = 0 < u ? f - 4 : f, v = 0; v < h; v += 4) {
          f = r[c.charCodeAt(v)] << 18 | r[c.charCodeAt(v + 1)] << 12 | r[c.charCodeAt(v + 2)] << 6 | r[c.charCodeAt(v + 3)], w[q++] = f >> 16 & 255, w[q++] = f >> 8 & 255, w[q++] = f & 255;
        }

        2 === u && (f = r[c.charCodeAt(v)] << 2 | r[c.charCodeAt(v + 1)] >> 4, w[q++] = f & 255);
        1 === u && (f = r[c.charCodeAt(v)] << 10 | r[c.charCodeAt(v + 1)] << 4 | r[c.charCodeAt(v + 2)] >> 2, w[q++] = f >> 8 & 255, w[q++] = f & 255);
        return w;
      };

      v.fromByteArray = function (c) {
        for (var f = c.length, n = f % 3, r = [], q = 0, h = f - n; q < h; q += 16383) {
          r.push(y(c, q, q + 16383 > h ? h : q + 16383));
        }

        1 === n ? (c = c[f - 1], r.push(w[c >> 2] + w[c << 4 & 63] + "\x3d\x3d")) : 2 === n && (c = (c[f - 2] << 8) + c[f - 1], r.push(w[c >> 10] + w[c >> 4 & 63] + w[c << 2 & 63] + "\x3d"));
        return r.join("");
      };

      var w = [],
          r = [],
          C = "undefined" !== typeof Uint8Array ? Uint8Array : Array;

      for (f = 0; 64 > f; ++f) {
        w[f] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[f], r["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(f)] = f;
      }

      r[45] = 62;
      r[95] = 63;
    }, {}]
  }, {}, [])("/");
});